{
  "courses": {
    "title": "Курси",
    "description": "Предмети з модулями та уроками.",
    "pupilDescription": "Курси з уроками, доступними вам.",
    "searchPlaceholder": "Пошук курсів…",
    "filter": {
      "label": "Показати",
      "active": "Активні",
      "archived": "Архівні",
      "all": "Усі"
    },
    "archivedBadge": "В архіві",
    "counts": "Модулів: {{modules}} · Уроків: {{lessons}}",
    "empty": {
      "title": "Ще немає курсів",
      "manageText": "Створіть перший курс і почніть наповнювати його уроками.",
      "pupilText": "Тут з’являються курси, які вчителі публікують для ваших класів, разом з їхніми уроками.",
      "filterText": "За цими фільтрами нічого не знайдено."
    },
    "create": {
      "button": "Створити курс",
      "title": "Новий курс",
      "description": "Назвіть предмет — модулі та уроки додасте далі.",
      "titleLabel": "Назва курсу",
      "titlePlaceholder": "напр. Математика, 7 клас",
      "descriptionLabel": "Опис",
      "descriptionPlaceholder": "Необов'язково — про що цей курс",
      "submit": "Створити курс",
      "submitting": "Створюємо…",
      "success": "Курс створено",
      "failed": "Не вдалося створити курс"
    },
    "edit": {
      "button": "Редагувати курс",
      "title": "Редагування курсу",
      "description": "Змініть назву курсу або його опис.",
      "submit": "Зберегти зміни",
      "submitting": "Зберігаємо…",
      "success": "Курс оновлено",
      "failed": "Не вдалося зберегти зміни"
    }
  },
  "standalone": {
    "title": "Окремі уроки",
    "description": "Уроки, що не належать до жодного курсу.",
    "empty": "Окремих уроків ще немає.",
    "newLessonTitle": "Назва нового уроку",
    "create": "Створити урок"
  },
  "course": {
    "back": "До списку курсів",
    "noDescription": "Без опису",
    "lessons": "Уроки",
    "noLessons": "Тут ще немає уроків.",
    "noVisibleLessons": "У цьому курсі вам ще не відкрили жодного уроку.",
    "courseLessons": "Уроки курсу",
    "courseLessonsDescription": "Уроки безпосередньо в курсі, поза модулями.",
    "newLessonTitle": "Назва нового уроку",
    "addLesson": "Додати урок",
    "addModuleTitle": "Новий модуль",
    "newModuleTitle": "Назва нового модуля",
    "addModule": "Додати модуль",
    "editLesson": "Редагувати «{{title}}»",
    "moveModuleUp": "Перемістити «{{title}}» вище",
    "moveModuleDown": "Перемістити «{{title}}» нижче",
    "moveLessonUp": "Перемістити урок «{{title}}» вище",
    "moveLessonDown": "Перемістити урок «{{title}}» нижче",
    "lessonNumber": "Урок {{n}}:",
    "module": {
      "rename": "Перейменувати «{{title}}»",
      "renameLabel": "Назва модуля",
      "renameSubmit": "Зберегти",
      "delete": "Видалити «{{title}}»",
      "deleteTitle": "Видалити модуль «{{title}}»?",
      "deleteDescription_zero": "У модулі немає уроків, тож більше нічого не зміниться.",
      "deleteDescription_one": "Його урок НЕ буде видалено — він перейде на рівень курсу й залишиться доступним. Зникне лише сам модуль.",
      "deleteDescription_few": "Його уроки ({{count}}) НЕ буде видалено — вони перейдуть на рівень курсу й залишаться доступними. Зникне лише сам модуль.",
      "deleteDescription_many": "Його уроки ({{count}}) НЕ буде видалено — вони перейдуть на рівень курсу й залишаться доступними. Зникне лише сам модуль.",
      "deleteDescription_other": "Його уроки ({{count}}) НЕ буде видалено — вони перейдуть на рівень курсу й залишаться доступними. Зникне лише сам модуль.",
      "deleteConfirm": "Видалити модуль",
      "deleted": "Модуль видалено"
    },
    "archive": {
      "button": "Архівувати курс",
      "title": "Архівувати «{{title}}»?",
      "description": "Курс та його уроки більше не можна буде редагувати, але вони залишаться доступними для перегляду. Скасувати архівування із застосунку неможливо.",
      "success": "Курс архівовано"
    }
  },
  "status": {
    "draft": "Чернетка",
    "published": "Опубліковано",
    "archived": "В архіві"
  },
  "blocks": {
    "rich_text": "Текст",
    "image": "Зображення",
    "video": "Відео",
    "audio": "Аудіо",
    "file": "Файл",
    "youtube": "YouTube",
    "link": "Посилання",
    "divider": "Розділювач"
  },
  "editor": {
    "title": "Редактор уроку",
    "back": "Назад",
    "view": "Переглянути",
    "publish": "Опублікувати",
    "unpublish": "Зняти з публікації",
    "duplicate": "Дублювати",
    "schedule": "Запланувати",
    "archive": "Архівувати",
    "lessonTitle": "Назва уроку",
    "course": "Курс",
    "noCourse": "Без курсу",
    "module": "Модуль",
    "noModule": "Без модуля",
    "teacherNotes": "Нотатки вчителя (приватні)",
    "teacherNotesHint": "Приватний план уроку та нотатки. Учні їх ніколи не бачать — це не частина змісту уроку.",
    "save": "Зберегти урок",
    "saved": "Урок збережено",
    "saveFailed": "Не вдалося зберегти урок",
    "unsaved": "Є незбережені зміни",
    "published": "Урок опубліковано",
    "unpublished": "Урок повернуто в чернетки",
    "duplicated": "Урок продубльовано — ви редагуєте копію",
    "archived": "Урок архівовано",
    "archiveTitle": "Архівувати «{{title}}»?",
    "archiveDescription": "Урок одразу зникне з усіх сторінок учнів. Скасувати архівування із застосунку неможливо.",
    "leaveTitle": "Відкинути незбережені зміни?",
    "leaveDescription": "Останні редагування не збережено — вони будуть втрачені.",
    "leaveConfirm": "Вийти без збереження",
    "blocksErrors": "Деякі блоки потребують виправлення:",
    "blocks": {
      "empty": "Ще немає вмісту — додайте перший блок нижче.",
      "add": "Додати блок",
      "moveUp": "Перемістити блок вище",
      "moveDown": "Перемістити блок нижче",
      "delete": "Видалити блок"
    },
    "toolbar": {
      "bold": "Жирний",
      "italic": "Курсив",
      "underline": "Підкреслений",
      "strike": "Закреслений",
      "h2": "Заголовок 2",
      "h3": "Заголовок 3",
      "bulletList": "Маркований список",
      "orderedList": "Нумерований список",
      "blockquote": "Цитата",
      "codeBlock": "Блок коду",
      "link": "Посилання",
      "linkUrl": "Адреса посилання",
      "linkApply": "Застосувати",
      "table": "Таблиця",
      "tableRow": "Рядок",
      "tableColumn": "Стовпець",
      "tableAddRow": "Додати рядок нижче",
      "tableDeleteRow": "Видалити рядок",
      "tableAddColumn": "Додати стовпець праворуч",
      "tableDeleteColumn": "Видалити стовпець",
      "tableHeaderRow": "Рядок заголовків",
      "tableDelete": "Видалити таблицю"
    },
    "asset": {
      "upload": "Завантажити",
      "replace": "Замінити",
      "uploading": "Завантажуємо… {{percent}}%",
      "progressLabel": "Перебіг завантаження",
      "caption": "Підпис",
      "label": "Назва",
      "hint": {
        "image": "JPEG, PNG, GIF або WebP, до 50 МБ.",
        "video": "MP4, WebM або QuickTime, до 50 МБ.",
        "audio": "MP3, MP4/AAC, OGG, WAV або WebM, до 50 МБ.",
        "file": "Документи, таблиці, презентації, текст або ZIP, до 50 МБ."
      }
    },
    "youtube": {
      "url": "Посилання на YouTube або id відео",
      "invalid": "Вставте дійсне посилання на відео YouTube або його id з 11 символів.",
      "previewTitle": "Попередній перегляд відео YouTube",
      "caption": "Підпис"
    },
    "link": {
      "url": "Адреса (URL)",
      "label": "Назва"
    }
  },
  "schedule": {
    "title": "Запланувати урок",
    "description": "Додайте урок до календаря класу. Учні побачать його після публікації уроку.",
    "classLabel": "Клас",
    "classPlaceholder": "Оберіть клас",
    "noClasses": "Немає активних класів — спершу створіть клас.",
    "startsAt": "Початок",
    "duration": "Тривалість (хвилин)",
    "submit": "Запланувати",
    "success": "Урок заплановано",
    "validation": "Оберіть клас і час початку"
  },
  "view": {
    "back": "Назад",
    "edit": "Редагувати",
    "teacherNotes": "Нотатки вчителя",
    "teacherNotesHint": "Бачить лише персонал — учням це поле ніколи не надсилається.",
    "empty": "У цьому уроці ще немає вмісту.",
    "assetUnavailable": "Вкладення недоступне.",
    "download": "Завантажити",
    "youtubeTitle": "Відео YouTube"
  },
  "validation": {
    "titleRequired": "Вкажіть назву"
  }
}
